import React, { Component } from 'react';
import { Container } from '@material-ui/core';
import { connect } from 'react-redux';
import * as actionsPresentacion from '../../../actions/nuevaPresentacion';
import * as actionsVentanaDialogo from '../../../actions/ventanaDialogo';
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router';
import uploadService from '../../../services/upload-files';
import styles from './styles';
import {
    BotonPrincipal,
    BotonSecundario,
} from '../../common/UI/Personalizaciones/Boton';
import Presentacion from '../../Presentacion/Presentacion';

class NuevaPresentacion extends Component {
    componentDidMount = () => {
        window.scrollTo(0, 0);
        this.props.inicializarNuevaPresentacion();
        this.props.recuperarPathTemporalParaArchivos();
        this.props.buscarTiposPresentaciones();
       // this.props.buscarTiposPrestaciones();
       // this.props.buscarTiposComprobantes();

        window.addEventListener('beforeunload', this.mantenerseEnLaPagina);
        window.addEventListener('unload', this.eliminarDatosCargados);
    };

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.mantenerseEnLaPagina);
        window.removeEventListener('unload', this.eliminarDatosCargados);
    }

    mantenerseEnLaPagina(e) {
        var message =
            'Advertecia!\n\nEstá seguro de que desea abandonar la página actual? Perderá todo el contenido cargado hasta el momento.';
        e.returnValue = message;
        return message;
    }

    eliminarDatosCargados = () => {
        if (this.props.pathTemporal !== null) {
            uploadService.cancelarPresentacion(this.props.pathTemporal);
        }
    };

    confirmarCancelarPresentacion = () => {
        const ventanaConfig = {
            estaVisible: true,
            titulo: '¿Está seguro que desea salir de la presentación?',
            mensaje: 'En caso de salir se perderán los cambios',
            esAlerta: true,
            clickAceptar: this.accionVolver,
            clickCancelar: () =>
                this.props.actualizarAtriutoVentanaDialogo({
                    estaVisible: false,
                }),
        };

        this.props.actualizarAtriutoVentanaDialogo(ventanaConfig);
    };

    accionVolver = () => {
        const ventanaConfig = {
            estaVisible: false,
        };
        this.props.actualizarAtriutoVentanaDialogo(ventanaConfig);
        this.eliminarDatosCargados();
        this.props.history.push('/');
    };

    render() {
        const { classes, submitValido, mostrarBackdrop } = this.props;

        return (
            <Container disableGutters={true}>
                <Presentacion />
                {!mostrarBackdrop && (
                    <Container
                        disableGutters={true}
                        className={classes.containerBotones}
                    >
                        <BotonSecundario
                            variant='outlined'
                            onClick={this.confirmarCancelarPresentacion}
                            className={classes.btnCancelar}
                        >
                            Cancelar
                        </BotonSecundario>
                        <BotonPrincipal
                            variant='contained'
                            onClick={this.props.enviarNuevaPresentacion}
                            className={classes.btnEnviar}
                            disabled={!submitValido}
                        >
                            Enviar Presentación
                        </BotonPrincipal>
                    </Container>
                )}
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    pathTemporal: state.nuevaPresentacionReducer.pathTemporal,
    emailResponsable: state.nuevaPresentacionReducer.emailResponsable,
    telefonoResponsable: state.nuevaPresentacionReducer.telefonoResponsable,
    submitValido: state.nuevaPresentacionReducer.submitValido,
    mostrarBackdrop: state.nuevaPresentacionReducer.mostrarBackdrop,
});

const actionCreators = {
    inicializarNuevaPresentacion:
        actionsPresentacion.inicializarNuevaPresentacion,
    buscarTiposComprobantes: actionsPresentacion.buscarTiposComprobantesPresentacion,
    enviarNuevaPresentacion: actionsPresentacion.enviarNuevaPresentacion,
    recuperarPathTemporalParaArchivos:
        actionsPresentacion.recuperarPathTemporalParaArchivos,
    buscarTiposPresentaciones: actionsPresentacion.buscarTiposPresentaciones,
    buscarTiposPrestaciones: actionsPresentacion.buscarTiposPrestacionesPresentacion,
    actualizarAtriutoVentanaDialogo:
        actionsVentanaDialogo.actualizarAtriutoVentanaDialogo,
};

export default connect(
    mapStateToProps,
    actionCreators
)(withStyles(styles)(withRouter(NuevaPresentacion)));
